/**
 * @description 制定规则
*/

// 发行活动码为唯一标识
const CMap = {
    CR2023: {
        title: 'Ape World共创漫画数字藏品', // 活动名称
        // 详情页宣传背景图
        adBg: require('@/assets/img/ape-world/cartoon_bg.png'),
        // 是否可分享，null:不可分享
        share: {
            bgImg: '',
            shareLink: ''
        },
        //数组：3D旋转的6张资源图，字符串: 本地图片资源
        sources: [
            require("@/assets/img/ape-world/cartoon_front.png"),
            require("@/assets/img/ape-world/cartoon_front.png"),
            require("@/assets/img/ape-world/cartoon_left.png"),
            require("@/assets/img/ape-world/cartoon_left.png"),
            require("@/assets/img/ape-world/cartoon_top.png"),
            require("@/assets/img/ape-world/cartoon_top.png")
        ],
        //详情页3d背景图或背景色
        sourceBg: require('@/assets/img/ape-world/sale_bg.png'),
        //详情显示文本控制: 0: 不可使用积分，1: 不可使用积分，可使用专属优惠券
        couponPoint: 0, 
        orderType: 0, //支付时后端定义的订单类型
    },
    gulandRec: {
        // 只有合成没有发售
        title: 'GULand矿工回收',
    },
    GuLandBlindBox: {
        title: '矿工猴盲盒发售',
        adBg: '',
        share: null,
        sources: undefined,
        orderType: 9,
    },
    SPACEBlindBox: {
        title: '空间盲盒发售', 
        adBg: require("@/assets/img/spaceBeautifulAccount/sale-top.png"),
        share: null,
        sources: [
            require("@/assets/img/spaceBeautifulAccount/box-front.png"),
            require("@/assets/img/spaceBeautifulAccount/box-front.png"),
            require("@/assets/img/spaceBeautifulAccount/box-left.png"),
            require("@/assets/img/spaceBeautifulAccount/box-left.png"),
            require("@/assets/img/spaceBeautifulAccount/box-up.png"),
            require("@/assets/img/spaceBeautifulAccount/box-up.png")
        ],
        orderType: 10,
    },
    europeanCup: {
        title: '欧洲杯', // 活动名称
        adBg: require('@/assets/img/eurocup/top_bg.png'), //宣传背景图
        share: null, // 是否可分享
        sources: undefined,
        couponPoint: 1,
        orderType: 11, //支付时后端定义的订单类型
    },
    apeBindBox: {
        title: 'Ape World配件盲盒',
        adBg: require('@/assets/img/partsBlindbox/detail_bg_top.png'),
        share: null,
        sources: [
            require("@/assets/img/partsBlindbox/front-back.png"),
            require("@/assets/img/partsBlindbox/front-back.png"),
            require("@/assets/img/partsBlindbox/left-right.png"),
            require("@/assets/img/partsBlindbox/left-right.png"),
            require("@/assets/img/partsBlindbox/up-down.png"),
            require("@/assets/img/partsBlindbox/up-down.png")
        ],
        couponPoint: 0,
        orderType: 12,
    },
    healthPreservation: {
        title: '绿地康养藏品',
        adBg: require('@/assets/img/kangYangNFT/detail_bg_top.png'),
        share: null,
        sources: [
            require("@/assets/img/kangYangNFT/front.jpg"),
            require("@/assets/img/kangYangNFT/front.jpg"),
            require("@/assets/img/kangYangNFT/left.png"),
            require("@/assets/img/kangYangNFT/left.png"),
            require("@/assets/img/kangYangNFT/up.png"),
            require("@/assets/img/kangYangNFT/up.png")
        ],
        couponPoint: 0,
        orderType: 13,
    },
    industrial: {
        title: 'APE WORLD配件盲盒',
        adBg: require('@/assets/img/industrialApe/detail_bg_top.png'),
        share: null,
        sources: [
            require("@/assets/img/industrialApe/front.jpg"),
            require("@/assets/img/industrialApe/front.jpg"),
            require("@/assets/img/industrialApe/left.png"),
            require("@/assets/img/industrialApe/left.png"),
            require("@/assets/img/industrialApe/up.png"),
            require("@/assets/img/industrialApe/up.png")
        ],
        couponPoint: 0,
        orderType: 14,
    },
    wxh: {
        title: '王小慧盲盒',
        adBg: require('@/assets/img/wangXiaoHui/bg_xq.png'),
        collectionId: '223',
        share: null,
        sources: [
            require("@/assets/img/wangXiaoHui/front.png"),
            require("@/assets/img/wangXiaoHui/front.png"),
            require("@/assets/img/wangXiaoHui/left.png"),
            require("@/assets/img/wangXiaoHui/left.png"),
            require("@/assets/img/wangXiaoHui/up.png"),
            require("@/assets/img/wangXiaoHui/up.png")
        ],
        couponPoint: 0,
        orderType: 15,
    },
    blindBoxSales: {
        title: 'Ape World共创藏品盲盒',
        adBg: require('@/assets/img/blindbox/detail_bg_top.png'),
        share: null,
        sources: [
            require("@/assets/img/blindbox/front-back.png"),
            require("@/assets/img/blindbox/front-back.png"),
            require("@/assets/img/blindbox/front-back.png"),
            require("@/assets/img/blindbox/front-back.png"),
            require("@/assets/img/blindbox/front-back.png"),
            require("@/assets/img/blindbox/front-back.png")
        ],
        couponPoint: 0,
        orderType: 18,
    },
    apeGold: {
        title: '藏品购买返利',
        adBg: require('@/assets/img/purchaseRebate/detailBg.png'),
        share: null,
        couponPoint: 0,
        orderType: 19,
    },
    apeWoodenBadge: {
        title: '木纹徽章',
        adBg: require('@/assets/img/woodGrainBadge/detailBg.png'),
        share: null,
        couponPoint: 0,
        orderType: 20,
    },
    claimNft: {
        title: '江苏十三太保',
        adBg: require('@/assets/img/culturalExchange/detailBg.png'),
        share: null,
        sources: [
            require("@/assets/img/culturalExchange/front-back.png"),
            require("@/assets/img/culturalExchange/other-back.png"),
            require("@/assets/img/culturalExchange/other-back.png"),
            require("@/assets/img/culturalExchange/other-back.png"),
            require("@/assets/img/culturalExchange/other-back.png"),
            require("@/assets/img/culturalExchange/other-back.png")
        ],
        couponPoint: 0,
        orderType: 22,
    },
    claimNft2: {
        title: '江苏十三太保二期',
        adBg: require('@/assets/img/culturalExchange_gold/detailBg@2x.png'),
        share: null,
        sources: [
            require("@/assets/img/culturalExchange_gold/front-back@2x.png"),
            require("@/assets/img/culturalExchange_gold/other-back@2x.png"),
            require("@/assets/img/culturalExchange_gold/other-back@2x.png"),
            require("@/assets/img/culturalExchange_gold/other-back@2x.png"),
            require("@/assets/img/culturalExchange_gold/other-back@2x.png"),
            require("@/assets/img/culturalExchange_gold/other-back@2x.png")
        ],
        couponPoint: 0,
        orderType: 23,
    },
    moutaiCb:{
        title: '茅台联名',
        adBg: require('@/assets/img/culturalExchange_seasons/detailBg.png'),
        share: null,
        // sources: [
        //     require("@/assets/img/culturalExchange_gold/front-back@2x.png"),
        //     require("@/assets/img/culturalExchange_gold/other-back@2x.png"),
        //     require("@/assets/img/culturalExchange_gold/other-back@2x.png"),
        //     require("@/assets/img/culturalExchange_gold/other-back@2x.png"),
        //     require("@/assets/img/culturalExchange_gold/other-back@2x.png"),
        //     require("@/assets/img/culturalExchange_gold/other-back@2x.png")
        // ],
        couponPoint: 0,
        orderType: 24,
    },
    pokerApe: {
        title: '无聊猿主题扑克牌',
        adBg: require('@/assets/img/culturalExchange_joker/detailBg@2x.png'),
        share: null,
        couponPoint: 0,
        orderType: 25,
    },
    healthPreBadge: {
        title: '康养藏品',
        adBg: require('@/assets/img/culturalExchange_kangyang/detailBg@2x.png'),
        share: null,
        couponPoint: 0,
        orderType: 27,
    },moutaiCb2:{
        title: '茅台联名二期',
        adBg: require('@/assets/img/culturalExchange_maotaisecond/detailBg.png'),
        share: null,
        sources: [
            require("@/assets/img/culturalExchange_maotaisecond/left-back@2x.png"),
            require("@/assets/img/culturalExchange_maotaisecond/left-back@2x.png"),
            require("@/assets/img/culturalExchange_maotaisecond/right-back@2x.png"),
            require("@/assets/img/culturalExchange_maotaisecond/right-back@2x.png"),
            require("@/assets/img/culturalExchange_maotaisecond/front-back@2x.png"),
            require("@/assets/img/culturalExchange_maotaisecond/front-back@2x.png")
        ],
        couponPoint: 0,
        orderType: 28,
        },airPort:{
            title: '在飞机上',
            adBg: require('@/assets/img/culturalExchange_onplane/detailBg.jpg'),
            share: null,
            // sources: [
            //     require("@/assets/img/culturalExchange_maotaisecond/left-back@2x.png"),
            //     require("@/assets/img/culturalExchange_maotaisecond/left-back@2x.png"),
            //     require("@/assets/img/culturalExchange_maotaisecond/right-back@2x.png"),
            //     require("@/assets/img/culturalExchange_maotaisecond/right-back@2x.png"),
            //     require("@/assets/img/culturalExchange_maotaisecond/front-back@2x.png"),
            //     require("@/assets/img/culturalExchange_maotaisecond/front-back@2x.png")
            // ],
            couponPoint: 0,
            orderType: 29,
        },UCL2025:{
            title: '欧洲杯1期',
            adBg: require('@/assets/img/culturalExchange_euro/detailBg@2x.jpg'),
            share: null,
            sources: [
                require("@/assets/img/culturalExchange_euro/left-back@2x.png"),
                require("@/assets/img/culturalExchange_euro/left-back@2x.png"),
                require("@/assets/img/culturalExchange_euro/left-back@2x.png"),
                require("@/assets/img/culturalExchange_euro/left-back@2x.png"),
                require("@/assets/img/culturalExchange_euro/left-back@2x.png"),
                require("@/assets/img/culturalExchange_euro/left-back@2x.png")
            ],
            couponPoint: 0,
            orderType: 30,
        },UCL20252nd:{
            title: '欧洲杯2期',
            adBg: require('@/assets/img/culturalExchange_euro/detailBg@2x.jpg'),
            share: null,
            sources: [
                require("@/assets/img/culturalExchange_euro/left-back@2x.png"),
                require("@/assets/img/culturalExchange_euro/left-back@2x.png"),
                require("@/assets/img/culturalExchange_euro/left-back@2x.png"),
                require("@/assets/img/culturalExchange_euro/left-back@2x.png"),
                require("@/assets/img/culturalExchange_euro/left-back@2x.png"),
                require("@/assets/img/culturalExchange_euro/left-back@2x.png")
            ],
            couponPoint: 0,
            orderType: 31,
        },mazu:{
            title: '妈祖',
            adBg: require('@/assets/img/culturalExchange_mazu/detailBg@2x.jpg'),
            share: null,
            sources: [
                require("@/assets/img/culturalExchange_mazu/left-back@2x.png"),
                require("@/assets/img/culturalExchange_mazu/left-back@2x.png"),
                require("@/assets/img/culturalExchange_mazu/right-back@2x.png"),
                require("@/assets/img/culturalExchange_mazu/right-back@2x.png"),
                require("@/assets/img/culturalExchange_mazu/front-back@2x.png"),
                require("@/assets/img/culturalExchange_mazu/front-back@2x.png")
            ],
            couponPoint: 0,
            orderType: 32,
        },carbonCredit:{
            title: '绿碳',
            adBg: require('@/assets/img/culturalExchange_greencarbon/detailBg@2x.jpg'),
            share: null,
            // sources: [
            //     require("@/assets/img/culturalExchange_mazu/left-back@2x.png"),
            //     require("@/assets/img/culturalExchange_mazu/left-back@2x.png"),
            //     require("@/assets/img/culturalExchange_mazu/right-back@2x.png"),
            //     require("@/assets/img/culturalExchange_mazu/right-back@2x.png"),
            //     require("@/assets/img/culturalExchange_mazu/front-back@2x.png"),
            //     require("@/assets/img/culturalExchange_mazu/front-back@2x.png")
            // ],
            couponPoint: 0,
            orderType: 33,
        },blindBoxPoint:{
            title: '藏品购买换积分',
            adBg: require('@/assets/img/culturalExchange_integral/detailBg@2x.jpg'),
            share: null,
            sources: [
                require("@/assets/img/culturalExchange_integral/left-back@2x.png"),
                require("@/assets/img/culturalExchange_integral/left-back@2x.png"),
                require("@/assets/img/culturalExchange_integral/right-back@2x.png"),
                require("@/assets/img/culturalExchange_integral/right-back@2x.png"),
                require("@/assets/img/culturalExchange_integral/front-back@2x.png"),
                require("@/assets/img/culturalExchange_integral/right-back@2x.png")
            ],
            couponPoint: 0,
            orderType: 35,
        },TaijiCarbon:{
            title: '太极碳元',
            adBg: require('@/assets/img/culturalExchange_taijigreencarbon/detailBg@2x.jpg'),
            share: null,
            sources: [
                require("@/assets/img/culturalExchange_taijigreencarbon/left-back@2x.png"),
                require("@/assets/img/culturalExchange_taijigreencarbon/left-back@2x.png"),
                require("@/assets/img/culturalExchange_taijigreencarbon/right-back@2x.png"),
                require("@/assets/img/culturalExchange_taijigreencarbon/right-back@2x.png"),
                require("@/assets/img/culturalExchange_taijigreencarbon/front-back@2x.png"),
                require("@/assets/img/culturalExchange_taijigreencarbon/front-back@2x.png")
            ],
            couponPoint: 0,
            orderType: 36,
        },
        DunHuangApe: {
            title: '敦煌典藏数字卡牌',
            adBg: require('@/assets/img/dunHuang/detailBg.png'),
            share: null,
            couponPoint: 0,
            orderType: 38,
        },
        dramaBlindBox: {
            title: '禁忌的色彩盲盒',
            adBg: require('@/assets/img/culturalExchange_huaju/gooddetail.png'),
            issuerLogo: require('@/assets/img/culturalExchange_huaju/logo.png'),
            share: null,
            sourcesMap: {
                481: [
                    require('@/assets/img/culturalExchange_huaju/roleleft.png'),
                    require('@/assets/img/culturalExchange_huaju/roleleft.png'),
                    require('@/assets/img/culturalExchange_huaju/roleleft.png'),
                    require('@/assets/img/culturalExchange_huaju/roleright.png'),
                    require('@/assets/img/culturalExchange_huaju/roletop.png'),
                    require('@/assets/img/culturalExchange_huaju/roletop.png'),
                ],
                482: [
                    require('@/assets/img/culturalExchange_huaju/accessoriesleft.png'),
                    require('@/assets/img/culturalExchange_huaju/accessoriesleft.png'),
                    require('@/assets/img/culturalExchange_huaju/accessoriesleft.png'),
                    require('@/assets/img/culturalExchange_huaju/accessoriesright.png'),
                    require('@/assets/img/culturalExchange_huaju/accessoriestop.png'),
                    require('@/assets/img/culturalExchange_huaju/accessoriestop.png'),
                ],
            },
            couponPoint: 0,
            orderType: 39,
        },
}

export {
    CMap,
};